import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import "./style.scss";

import "antd/dist/antd.css";

/* antd icons */
import {
  CrownOutlined,
  HomeOutlined,
  ShoppingCartOutlined,
  TagOutlined,
  ContactsOutlined,
  AuditOutlined,
  ClusterOutlined,
  UserOutlined,
  FileProtectOutlined,
} from "@ant-design/icons";

import { Layout, Menu } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import interaction from "../../../../assets/svg/intractions_icon.svg";
import action_black from "../../../../assets/svg/audit_icon.svg";
import metrics_icon from "../../../../assets/imgs/function.png";
import axios from "axios";
import config from "../../../../config";
const { Sider } = Layout;

const Sidebar = () => {
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState(location.pathname);
  const [roles, setRoles] = useState(null);
  const token = localStorage.getItem("token");
  // Derive isAdmin once from fetched roles so we can reuse it for multiple menu items
  const isAdmin = Array.isArray(roles) && roles.some((r) => String(r).toLowerCase() === "admin");
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const permissionsResponse = await axios.post(
          `${config.backendHost}auth/permissions`,
          {
            access_token: token,
          }
        );
        setRoles(permissionsResponse.data.roles);
      }
      catch (error) {
        console.error("Error fetching roles:", error);
      }
    }
    fetchRoles();
  }, []);
  const handleMenuClick = (e) => {
    if (e.key === selectedKey) {
      // window.location.reload();
      setSelectedKey(e.key);
    } else {
      setSelectedKey(e.key);
      // window.location.reload();
    }
  };

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type: key.includes("divider") ? "group" : undefined, // Allows divider styling
      // `disabled` will be attached when provided as a sixth arg (kept for compatibility)
      disabled: arguments.length >= 6 ? arguments[5] : undefined,
    };
  }
  const dividerStyle = { backgroundColor: "lightgray", height: "2px", margin: "0px 8px" };

  const items = [
    getItem(
      "Customers",
      "/customers",
      <Link key="customers-link" to="/customers">
        <CrownOutlined />
      </Link>
    ),
    getItem(
      "Tenants",
      "/tenants",
      <Link key="tenants-link" to="/tenants">
        <HomeOutlined />
      </Link>
    ),

    { type: "divider", style: dividerStyle },


    // Build Contracts submenu children and include ProtoContracts only for admin
    (() => {
      const isAdmin = Array.isArray(roles) && roles.some((r) => String(r).toLowerCase() === "admin");
      const contractChildren = [
        getItem(
          "Metrics",
          "/metrics",
          <Link key="metrics-link" to="/metrics" />
        ),
        getItem(
          "Agreements",
          "/agreements",
          <Link key="agreements-link" to="/agreements" />
        ),
      ];

      // Always show the ProtoContracts item but disable it for non-admins
      // contractChildren.push(
      //   getItem(
      //     "ProtoContracts",
      //     "/proto-contract",
      //     <Link key="proto-contract-link" to="/proto-contract" />,
      //     null,
      //     null,
      //     !isAdmin // disabled when not admin
      //   )
      // );
      // contractChildren.push(
      //   getItem(
      //     "Contracts",
      //     "/contract",
      //     <Link key="contract-link" to="/contract" />,
      //     null,
      //     null,
      //     !isAdmin // disabled when not admin
      //   )
      // );

      return getItem("Contracts", "contract", <img src={metrics_icon} style={{ text: "bold" }} alt="metrics" />, contractChildren);
    })(),

    { type: "divider", style: dividerStyle },

    getItem(
      "Customer Interactions",
      "/customer-interactions",
      <Link key="customer-interactions-link" to="/customer-interactions">
        <img src={interaction} style={{ text: "bold" }} alt="interaction" />
      </Link>
    ),
    getItem(
      "Customer Action Items",
      "/customer-action-items",
      <Link key="customer-action-items-link" to="/customer-action-items">
        <img src={action_black} style={{ text: "bold" }} alt="interaction" />
      </Link>
    ),
    { type: "divider", style: dividerStyle },
    getItem(
      "User Roles",
      "/user-roles",
      <Link key="user-roles-link" to="/user-roles">
        <UserOutlined />
      </Link>
    ),
    getItem(
      "Tags",
      "tags",

      <TagOutlined />,
      [
        getItem(
          "Business Tags",
          "/business-tags",
          <Link key="business-tags-link" to="/business-tags" />
        ),
        getItem(
          "Data Mastering Tags",
          "/datamastering-tags",
          <Link key="datamastering-tags-link" to="/datamastering-tags" />
        ),
        getItem(
          "My Tags",
          "/my-tags",
          <Link key="my-tags-link" to="/my-tags" />
        ),
        // getItem(
        //   "Clustering Tags",
        //   "/clustering-tags",
        //   <Link key="clustering-tags-link" to="/clustering-tags" />
        // ),
      ]
    ),


    getItem("Carts", "carts", <ShoppingCartOutlined />, [
      getItem(
        "Customer Cart",
        "/customer-cart",
        <Link key="customer-cart-link" to="/customer-cart" />
      ),
      getItem(
        "Tenant Cart",
        "/tenant-cart",
        <Link key="tenant-cart-link" to="/tenant-cart" />
      ),
    ]),
    getItem("Audit logs", "audit", <AuditOutlined />, [
      getItem(
        "Customer Database Audit",
        "/customer-database-audit",
        <Link
          key="customer-database-audit-link"
          to="/customer-database-audit"
        />
      ),
      getItem(
        " Child Customer Audit",
        "/child-customer-audit",
        <Link key="child-customer-audit-link" to="/child-customer-audit" />
      ),
      getItem(
        "Customer Merge Audit",
        "/customer-merge-audit",
        <Link key="customer-merge-audit-link" to="/customer-merge-audit" />
      ),
      getItem(
        "Tenant Database Audit",
        "/tenant-database-audit",
        <Link key="tenant-database-audit-link" to="/tenant-database-audit" />
      ),
      getItem(
        "Mapping Audit",
        "/mapping-audit",
        <Link key="mapping-audit-link" to="/mapping-audit" />
      ),
      getItem(
        "Metric Audit",
        "/metrics-audit",
        <Link key="contracts-audit-link" to="/metrics-audit" />
      ),
      getItem(
        "Agreements Audit",
        "/agreements-audit",
        <Link key="contracts-audit-link" to="/agreements-audit" />
      ),
      // getItem(
      //   "ProtoContracts Audit",
      //   "/proto-contract-audit",
      //   <Link key="contracts-audit-link" to="/proto-contract-audit" />,
      //   null,
      //   null,
      //   !isAdmin // disable for non-admins
      // ),
      // getItem(
      //   "Contracts Audit",
      //   "/contract-audit",
      //   <Link key="contract-audit-link" to="/contract-audit" />,
      //   null,
      //   null,
      //   !isAdmin // disable for non-admins
      // ),
    ]),

    // getItem("Clustering", "/clustering", <Link key="clustering-link" to="/clustering"><ClusterOutlined /></Link>),
  ];

  return (
    <Sider className="sider-style" collapsedWidth="50px" collapsed>
      <Menu
        className="menu-style"
        onClick={handleMenuClick}
        defaultSelectedKeys={[selectedKey]}
        theme="light"
        mode="inline"
        items={items}
      />
    </Sider>
  );
};

export default Sidebar;
